// Worker job-list scope: 'mine' = assigned directly to me, 'team' = plus my team's jobs.
// A worker's own choice (stored per browser) wins over the company default.
export const JOB_SCOPE_KEY = 'ht_jobs_scope';

const norm = (v) => (v === 'team' ? 'team' : 'mine');

export const hasJobScopePref = () => {
  try { return localStorage.getItem(JOB_SCOPE_KEY) != null; } catch { return false; }
};

export const getJobScope = (fallback = 'mine') => {
  try {
    const v = localStorage.getItem(JOB_SCOPE_KEY);
    return v == null ? norm(fallback) : norm(v);
  } catch { return norm(fallback); }
};

export const saveJobScope = (scope) => {
  try { localStorage.setItem(JOB_SCOPE_KEY, norm(scope)); } catch { /* ignore */ }
};
